<app-stepper-form
  header="Voluntary Deregistration"
  subheader="Form 6010"
  formIcon="ic-voluntary-de-registration-20"
  [steps]="stepsSignal()"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>

  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="6010"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.ApplicantDeclaration"
      [hidden]="currentStep !== StepsEnum.ApplicantDeclaration"
    >
      <h1 class="h1-heading">{{ stepsSignal()[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-checkbox
          label="I declare that the statements below are correct"
          formControlName="declarationNoAssetsLiabilities"
        />
      </div>

      <ol class="voluntary-deregistration-declarations">
        @for (declaration of voluntaryDeregistrationDeclarations; track declaration) {
          <li>{{ declaration }}</li>
        }
      </ol>
    </section>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.DetailsOfTheApplicant"
      [hidden]="currentStep !== StepsEnum.DetailsOfTheApplicant"
    >
      <h1 class="h1-heading">{{ stepsSignal()[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-radio
          label="Is the Applicant"
          formControlName="isApplicantDirector"
          [options]="isApplicantDirectorOptions"
        />
      </div>

      <div [hidden]="detailsOfTheApplicantForm.controls.isApplicantDirector.value !== true">
        <!-- Director Selected -->

        <div class="form-group">
          <app-select
            label="Director"
            formControlName="applicantIfDirector"
            [options]="directorsOptions"
            [valuePrimitive]="true"
          />
        </div>
      </div>

      <div
        [formGroup]="detailsOfTheApplicantForm"
        [hidden]="detailsOfTheApplicantForm.controls.isApplicantDirector.value !== false"
      >
        <h3 class="h3-heading">Nominee Details</h3>

        <div class="form-group">
          <app-individual-data-form-group
            [formGroup]="detailsOfTheApplicantForm.controls.applicantIfNominee"
            [hiddenControls]="disabledIndividualControlKeys"
          />
        </div>
      </div>

      <div class="form-group">
        <app-radio
          label="Payment Method"
          formControlName="paymentMethod"
          [options]="paymentMethodOptions"
        />
      </div>
    </section>

    <app-authorised-signatories-step
      [hidden]="currentStep !== StepsEnum.AuthorisedSignatories"
      [title]="stepsSignal()[currentStepIndex].label"
      [formGroup]="authorisedSignatoriesForm"
      [securityRegistryRecords]="securityRegistryRecords"
    />
  </div>
</app-stepper-form>
